import Paginate from 'vuejs-paginate'
import Status from '@/components/status'
import swal from 'sweetalert'
import Create from '../create'
import Edit from '../edit'
export default {
  name: 'list-checklist-item',
  components: { Paginate, Status, Create, Edit },
  props: ['group'],
  data () {
    return {
      loading: false,
      per_page: 20,
      sort: 'desc',
      search: '',
      status: '',
      groups: [],
      page: 1,
      showFilter: false,
      check_all: false
    }
  },
  computed: {
    checklist_items () {
      return this.$store.getters['ChecklistItem/getListChecklistItem']
    },
    last_page () {
      return this.$store.getters['ChecklistItem/getLastPage']
    },
    total () {
      return this.$store.getters['ChecklistItem/getTotal']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    },
    show () {
      return this.$store.getters['ChecklistItem/getOpenChecklistItem']
    }
    // groups () {
    //   return this.$store.getters['GroupChecklistItem/getListGroupChecklistItem']
    // }
  },
  mounted () {
    // ()
    // this.loading = true
    // Promise.all([
    //   this.initData(),
    //   this.$store.dispatch('Status/getListStatus'),
    //   this.$store.dispatch('GroupChecklistItem/getListGroupChecklistItem', {page: this.page, per_page: 'all'})
    // ]).then(res => {
    //   this.groups = res[2]
    //   
    //   this.loading = false
    // }).catch(errors => {
    //   this.loading = false
    //   
    // })
  },
  methods: {
    initData () {
      return this.$store.dispatch('ChecklistItem/getListChecklistItem', { page: 1, per_page: this.per_page, status: this.status, search: this.search, sort: this.sort, group: this.group.id })
    },
    changeTotal () {
    
      // this.loading = true
      Promise.all([
        this.initData(),
        this.$store.dispatch('Status/getListStatus')
      ]).then(res => {
        
        // this.loading = false
      }).catch(errors => {
        this.loading = false
        // 
      })
    },
    changePage (page) {
      this.page = page
    
      // this.loading = true
      Promise.all([
        this.initData(),
        this.$store.dispatch('Status/getListStatus')
      ]).then(res => {
        
        // this.loading = false
      }).catch(errors => {
        this.loading = false
        // 
      })
    },
    destroy (checklist_item = {}) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
          
            this.$store.dispatch('ChecklistItem/destroyChecklistItem', {
              checklist_item
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              
            }).catch(errors => {
              
            })
          }
        })
    },
    edit (checklist_item = {}) {
    
      this.$store.dispatch('ChecklistItem/showChecklistItem', { checklist_item }).then(res => {
        this.$refs.edit.show(res)
        
      }).catch(errors => {
        
      })
    },
    approval (checklist_item = {}) {
    
      this.$store.dispatch('ChecklistItem/approvalChecklistItem', {
        checklist_item
      }).then(res => {
        checklist_item.status = res.status
        // var tamp = true
        // this.checklist_items.forEach(element => {
        //   if (element.status.code === 2) {
        //     tamp = false
        //   }
        // })
        // if (tamp) {
        //   this.$store.commit('GroupChecklistItem/setIsApproval', this.group)
        // }
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        
      }).catch(errors => {
        
      })
    },
    rejection (checklist_item = {}) {
    
      this.$store.dispatch('ChecklistItem/rejectChecklistItem', {
        checklist_item
      }).then(res => {
        this.$store.commit('GroupChecklistItem/setIsReject', this.group)
        checklist_item.status = res.status
        
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        
      })
    },
    filter () {
    
      this.initData().then(res => {
        
      }).catch(errors => {
        
      })
    },
    _showFilter () {
      this.showFilter = !this.showFilter
    },
    _create () {
      if(this.group.status.code != 1){
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('notify.notify'),
          text: this.$t('notify.status_error')
        })
      }else{
      
        this.$store.dispatch('ChecklistItem/getHeaderChecklistItem', { group: this.group }).then(res => {
          
          this.$refs.create.show(this.group, res)
        }).catch(errors => {
          
        })
      }
      
    },
    checkAll () {
      this.checklist_items.forEach(element => {
        element.select = this.check_all
      })
    },
    isTick () {
      var data = []
      this.checklist_items.forEach(element => {
        if (element.select) {
          data.push(element)
        }
      })
      return data.length !== 0
    },
    multiDestroy () {
      var ids = []
      this.checklist_items.forEach(element => {
        if (element.select) {
          ids.push(element.id)
        }
      })
      if (!ids.length) {
        swal({
          title: 'Chưa có bản ghi nào được chọn',
          icon: 'warning'
        })
      } else {
        swal({
          title: this.$t('notify.delete_comfirm'),
          icon: 'warning',
          buttons: true,
          dangerMode: true
        })
          .then((willDelete) => {
            if (willDelete) {
            
              this.$store.dispatch('ChecklistItem/multiDestroyChecklistItem', {
                ids
              }).then((res) => {
                this.initData().then(res => {
                  
                  this.$notify({
                    group: 'success',
                    title: this.$t('notify.notify'),
                    text: this.$t('notify.delete_success')
                  })
                  this.check_all = false
                })
              }).catch(errors => {
                
              })
            }
          })
      }
    },
    multiRejection () {
      var ids = []
      this.checklist_items.forEach(element => {
        if (element.select) {
          ids.push(element.id)
        }
      })
      if (!ids.length) {
        swal({
          title: 'Chưa có bản ghi nào được chọn',
          icon: 'warning'
        })
      } else {
      
        this.$store.dispatch('ChecklistItem/multiRejectChecklistItem', {
          ids
        }).then(res => {
          this.initData().then(res => {
            this.$store.commit('GroupChecklistItem/setIsReject', this.group)
            
            this.$notify({
              group: 'success',
              title: this.$t('notify.notify'),
              text: this.$t('notify.update_success')
            })
            this.check_all = false
          })
        }).catch(errors => {
          
        })
      }
    },
    multiApproval () {
      var ids = []
      this.checklist_items.forEach(element => {
        if (element.select) {
          ids.push(element.id)
        }
      })
      if (!ids.length) {
        swal({
          title: 'Chưa có bản ghi nào được chọn',
          icon: 'warning'
        })
      } else {
      
        this.$store.dispatch('ChecklistItem/multiApprovalChecklistItem', {
          ids
        }).then(res => {
          this.initData().then(res => {
            // var tamp = true
            // this.checklist_items.forEach(element => {
            //   if (element.status.code === 2) {
            //     tamp = false
            //   }
            // })
            // if (tamp) {
            //   this.$store.commit('GroupChecklistItem/setIsApproval', this.group)
            // }
            
            this.$notify({
              group: 'success',
              title: this.$t('notify.notify'),
              text: this.$t('notify.update_success')
            })
            this.check_all = false
          })
        }).catch(errors => {
          
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist-item/list-checklist-item/list.js